export enum NoteType {
    NotaFiscal = 1,
    NotaDebito = 2
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/NoteType.ts